import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '~/components/app-shell'
import { UsagePage } from '~/components/billing/usage-page'
import { SettingsNav } from '~/components/settings-nav'

export const Route = createFileRoute('/_authed/app/settings/usage')({
  head: () => ({ meta: [{ title: `${m.usage_title()} - ${m.app_name()}` }] }),
  component: UsageRoute,
})

function UsageRoute() {
  return (
    <>
      <SettingsNav />
      <PageHeader title={m.usage_title()} />
      <UsagePage />
    </>
  )
}
